<ng-container *ngIf="userSubscription?.type === userSubscriptionType?.FREE || userSubscription?.trialBoosterClient">
  <div class="db-paid-feature-upgrade__action {{step}}"
       [ngClass]="{'full-width': (!!newPlans && !['features', 'checkout'].includes(step))}"
       [ngSwitch]="step">
    <ng-container *ngIf="mode !== 'pro-level'">
      <db-paid-feature-upgrade-features
        *ngSwitchCase="'features'" @slide
        [isAgency]="isAgency"
        [mode]="mode"
        (onStepChange)="step = $event"></db-paid-feature-upgrade-features>
    </ng-container>

    <ng-container *ngIf="mode === 'pro-level'">
      <db-pro-booster-upgrade
        *ngSwitchCase="'features'" @slide
        [mode]="mode"
        (onStepChange)="step = $event"></db-pro-booster-upgrade>
    </ng-container>

    <ng-container *ngIf="!!newPlans && !isEcommerce">
      <db-one-week-free-demo
                             *ngSwitchCase="'plans'" @slide
                             [user]="user"
                             [showBackButton]="true"
                             [paidFeature]="true"
                             [isEcommerceWebsite]="isEcommerce"
                             [currentSubscription]="userSubscription"
                             [englishCountries]="englishCountries"
                             [step]="2" [showAnnual]="true"
                             (onStepChange)="step = $event; resize();"
                             (onPlanChange)="changePlan($event)"
      ></db-one-week-free-demo>
    </ng-container>

    <ng-container  *ngIf="!!newPlans && isEcommerce">
      <db-one-week-free-demo-ecommerce
        *ngSwitchCase="'plans'" @slide
        [user]="user"
        [showBackButton]="true"
        [paidFeature]="true"
        [isEcommerceWebsite]="isEcommerce"
        [currentSubscription]="userSubscription"
        [englishCountries]="englishCountries"
        [step]="2" [showAnnual]="true"
        (onStepChange)="step = $event; resize();"
        (onPlanChange)="changePlan($event)"
      ></db-one-week-free-demo-ecommerce>
    </ng-container>


    <ng-container *ngIf="!newPlans">

      <db-paid-feature-upgrade-plans
        *ngSwitchCase="'plans'" @slide
        [currentSubscription]="userSubscription"
        [isAgency]="isAgency"
        [chosenPlan]="chosenPlan"
        [expirationDate]="expirationDate"
        (onStepChange)="step = $event"
        [mode]="mode"
        (onPlanChange)="changePlan($event)"></db-paid-feature-upgrade-plans>
    </ng-container>

    <db-paid-feature-upgrade-checkout
      *ngSwitchCase="'checkout'" @slide
      [userSubscription]="userSubscription"
      [chosenPlan]="chosenPlan" [buyAdditionalWord]="buyAdditionalWord"
      [expirationDate]="expirationDate"
      [mode]="mode"
      (onStepChange)="step = $event"
      (onClose)="closeModal($event)"></db-paid-feature-upgrade-checkout>
  </div>
</ng-container>

<div class="db-paid-feature-upgrade__action"
     *ngIf="userSubscription?.type !== userSubscriptionType?.FREE">

  <db-paid-feature-upgrade-checkout
    [userSubscription]="userSubscription"
    [chosenPlan]="chosenPlan"
    [expirationDate]="expirationDate"
    [mode]="mode"
    (onStepChange)="step = $event"
    (onClose)="closeModal($event)"></db-paid-feature-upgrade-checkout>
</div>

<div class="db-paid-feature-upgrade__banner {{step}} {{userSubscription?.type}} {{userSubscriptionType?.FREE}}" [ngSwitch]="step">
  <ng-container *ngIf="userSubscription?.type === userSubscriptionType?.FREE && (!newPlans || (!!newPlans && ['features', 'checkout'].includes(step)))">
    <div *ngSwitchCase="'features'" @scale class="banner" [ngClass]="{'pro-level': mode === 'pro-level'}"></div>

    <db-paid-feature-upgrade-banner *ngSwitchCase="'checkout'" @scale class="mb30"
                                    [ngStyle]="{position: 'absolute', left: '40px', right: '40px'}"
                                    [ngClass]="{'ssh-banner': mode === 'ssh' || mode === 'cloudflare' || mode ===
                                    'passwordProtect'}"
                                    [expirationDate]="expirationDate"
                                    [userSubscription]="userSubscription"
                                    [boosterPro]="mode === 'pro-level'"></db-paid-feature-upgrade-banner>

    <db-paid-feature-upgrade-banner *ngSwitchDefault @scale class="mb30"
                                    [ngStyle]="{position: 'absolute', left: '40px', right: '40px'}"
                                    [ngClass]="{'ssh-banner': mode === 'ssh' || mode === 'cloudflare' || mode ===
                                    'passwordProtect'}"
                                    [expirationDate]="expirationDate"
                                    [userSubscription]="userSubscription"
    [boosterPro]="mode === 'pro-level'"></db-paid-feature-upgrade-banner>
  </ng-container>

  <db-paid-feature-upgrade-banner *ngIf="userSubscription?.type !== userSubscriptionType?.FREE" @scale class="mb30"
                                  [ngStyle]="{position: 'absolute', left: '40px', right: '40px'}"
                                  [expirationDate]="expirationDate"
                                  [userSubscription]="userSubscription"></db-paid-feature-upgrade-banner>
</div>

